import React, { useState, useEffect } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import {
    useLoaderData,
} from "react-router-dom";
import { getUserProfiles } from "../../../data/admin/userProfiles";

// Badge d'origine de creation : web / android / ios (— si inconnu / historique).
export function sourceLabel(source) {
    const map = {
        web: { text: "Web", color: "#2b6cb0" },
        android: { text: "Android", color: "#2e7d32" },
        ios: { text: "iOS", color: "#333" },
    };
    const conf = map[(source || "").toLowerCase()];
    if (!conf) {
        return <span style={{ color: "#aaa" }}>—</span>;
    }
    return (
        <span style={{
            display: "inline-block", padding: "2px 8px", borderRadius: 10,
            fontSize: 12, fontWeight: 600, color: "#fff", background: conf.color,
        }}>{conf.text}</span>
    );
}

// Badge "mode vacances" : vert si actif maintenant, orange si programmé, avec la période.
export function holidayBadge(rowData) {
    if (!rowData || !rowData.holidaysMode) {
        return <span style={{ color: "#aaa" }}>—</span>;
    }
    const fmt = (v) => (v ? new Date(v).toLocaleDateString("fr-FR") : null);
    const start = fmt(rowData.holidayStartDate);
    const end = fmt(rowData.holidayEndDate);
    let period = "sans échéance";
    if (start && end) period = `${start} → ${end}`;
    else if (start) period = `dès le ${start}`;
    else if (end) period = `jusqu'au ${end}`;
    const active = rowData.isCurrentlyOnHoliday;
    return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            <span style={{
                display: "inline-block", padding: "2px 8px", borderRadius: 10,
                fontSize: 12, fontWeight: 600, color: "#fff",
                background: active ? "#2e7d32" : "#b26a00",
            }}>{active ? "🌴 En vacances" : "🗓 Prévu"}</span>
            <span style={{ color: "#777", fontSize: 12 }}>{period}</span>
        </span>
    );
}

export async function loader({ params }) {

    const userprofiles = await getUserProfiles()

    return { userprofiles };
    
}
export default function UserProfileList() {

    const { userprofiles } = useLoaderData();
    const [filters, setFilters] = useState(null);
    const [loading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(() => {

        initFilters();
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'country.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            representative: { value: null, matchMode: FilterMatchMode.IN },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            balance: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
            verified: { value: null, matchMode: FilterMatchMode.EQUALS }
        });
        setGlobalFilterValue('');
    };

    const renderHeader = () => {
        return (
            <div className="flex">
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText className="w-full" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Rechercher..." />
                </span>
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        let link = `/user/${rowData.userId}`
        return (<a href={link} rel="noopener noreferrer" >
            <i className="pi pi-user" ></i> Détails
        </a>);
    };

    const accountTypeBodyTemplate = (rowData) => {
        return rowData.isProfessional ? `Professionnel${rowData.companyName ? " - " + rowData.companyName : ""}` : "Particulier";
    };




    const header = renderHeader();
    return (
        <div>
          
            <h2>Liste des utilisateurs</h2>


           
            <div className="card">
                <DataTable value={userprofiles.items} paginator showGridlines rows={50} loading={loading} dataKey="id" filters={filters} globalFilterFields={['userId', 'firstname', 'lastname', 'email', 'phone']} header={header} emptyMessage="Aucun utilisateur trouv&eacute;">
                    <Column header="Id" field="userId" />
                    <Column header="Prénom" field="firstname" />
                    <Column header="Nom" field="lastname" />
                    <Column header="Email" field="email" />
                    <Column header="Téléphone" field="phone" />
                    <Column header="Compte" field="isProfessional" body={accountTypeBodyTemplate} />
                    <Column header="Créé le" field="createdAt" body={(rowData) => new Date(rowData.createdAt).toLocaleDateString('fr-FR')} />
                    <Column header="Source" field="creationSource" body={(rowData) => sourceLabel(rowData.creationSource)} />
                    <Column header="Vacances" body={(rowData) => holidayBadge(rowData)} />
                    <Column header="" body={actionBodyTemplate} />
                </DataTable>


            </div> 
           


        </div>
    );
}
